/* eslint-disable import/extensions */
import './global.js';
// import "~/assets/css/autobahn.css";
import '~/scss/pages/landing.scss';
import Vue from 'vue';
import app from '~/components/signup/app.vue';

// eslint-disable-next-line no-unused-vars
const landing = new Vue({
    render: (createElement) => createElement(app),
}).$mount('#app');
